export default __webpack_public_path__ + "media/FoundersHubAIassistantSupplementalTerms.7b66d180.pdf";